export enum OpenLinksType {
	NewWindow = 1,
	CurrentWindow = 2
}